import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Crown, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("qru.education@gmail.com");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0F1D] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2.5 justify-center mb-8">
          <span className="w-10 h-10 rounded-xl bg-[#3B1F6E] flex items-center justify-center"><Crown className="w-5 h-5 text-[#D97706]" /></span>
          <span className="font-serif-display text-2xl font-semibold text-white">QRU Quick Publisher</span>
        </div>
        <form onSubmit={submit} className="bg-[#111827] border border-white/10 rounded-2xl p-8">
          <h1 className="text-white font-semibold text-lg mb-1">Founder Sign In</h1>
          <p className="text-slate-400 text-sm mb-6">Publishing console access.</p>
          <label className="block text-xs font-semibold text-slate-400 mb-1.5">Email</label>
          <input data-testid="login-email" value={email} onChange={(e) => setEmail(e.target.value)} type="email"
            className="w-full h-11 rounded-lg bg-[#0A0F1D] border border-white/10 text-white px-3 mb-4 focus:outline-none focus:ring-2 focus:ring-[#3B1F6E]" />
          <label className="block text-xs font-semibold text-slate-400 mb-1.5">Password</label>
          <input data-testid="login-password" value={password} onChange={(e) => setPassword(e.target.value)} type="password"
            className="w-full h-11 rounded-lg bg-[#0A0F1D] border border-white/10 text-white px-3 mb-6 focus:outline-none focus:ring-2 focus:ring-[#3B1F6E]" />
          <button data-testid="login-submit" disabled={loading} type="submit"
            className="w-full h-11 bg-[#D97706] hover:bg-[#B45309] disabled:opacity-60 text-white rounded-lg font-semibold flex items-center justify-center gap-2">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
